
export default function Credentials() {
  return (
    <section id="credentials" className="bg-[#0A0A0A] py-16 sm:py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-100 mb-3 sm:mb-4">
            Professional Credentials & Regulatory Compliance
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-400 max-w-3xl mx-auto px-4 sm:px-0">
            All our personnel maintain active registration with the UK's leading medical regulatory bodies, 
            ensuring the highest standards of professional competency and ethical practice.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto">
          {/* GMC Registration */}
          <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 flex items-center justify-center bg-blue-50 rounded-full">
              <img 
                src="https://public.readdy.ai/ai/img_res/11f5ee8dea8a947e3569e6a24d43614e.jpg" 
                alt="GMC - General Medical Council"
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
              />
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
              GMC Registration
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
              General Medical Council
            </p>
            <p className="text-xs sm:text-sm text-gray-500">
              Our medical practitioners maintain active registration with the GMC, 
              the statutory body that regulates doctors in the UK, ensuring they meet 
              the highest standards of medical practice and professional conduct.
            </p>
          </div>

          {/* NMC Registration */}
          <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 flex items-center justify-center bg-teal-50 rounded-full">
              <img 
                src="https://readdy.ai/api/search-image?query=Nursing%20and%20Midwifery%20Council%20NMC%20official%20logo%20professional%20nursing%20regulatory%20body%20teal%20and%20white%20clean%20design%20healthcare%20authority%20symbol&width=80&height=80&seq=nmc-logo-001&orientation=squarish" 
                alt="NMC - Nursing and Midwifery Council"
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
              />
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
              NMC Registration
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
              Nursing and Midwifery Council
            </p>
            <p className="text-xs sm:text-sm text-gray-500">
              Our nursing professionals are registered with the NMC, the regulatory 
              body for nursing and midwifery in the UK, guaranteeing they maintain 
              current competencies and adhere to strict professional standards.
            </p>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="mt-8 sm:mt-12 text-center">
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 md:gap-8 text-xs sm:text-sm text-gray-500">
            <div className="flex items-center">
              <i className="ri-shield-check-line text-green-600 mr-2"></i>
              Verified Credentials
            </div>
            <div className="flex items-center">
              <i className="ri-user-star-line text-blue-600 mr-2"></i>
              Active Registration
            </div>
            <div className="flex items-center">
              <i className="ri-award-line text-purple-600 mr-2"></i>
              Continuous Professional Development
            </div>
            <div className="flex items-center">
              <i className="ri-file-shield-2-line text-orange-600 mr-2"></i>
              Regulatory Compliance
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
